import PropTypes from 'prop-types';
import {
  checkIfExitBlockElement,
  EMPHASIS_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

import { Emphasis } from './Emphasis';

const EmphasisPlugin = ({ className, EMPHASIS_TAG, ...attributes } = {}) => ({
  renderElement: Emphasis({
    className,
    EMPHASIS_TAG,
    ...attributes,
  }),
  onKeyDown: checkIfExitBlockElement({ blockType: EMPHASIS_DEFINITIONS.type }),
});

EmphasisPlugin.propTypes = {
  className: PropTypes.string,
  EMPHASIS_TAG: PropTypes.node,
};

export { EmphasisPlugin };
